import { Trans } from "react-i18next";

import { useCurrentSubscriptionExpired, useSubscriptionExpiringWithinMonth } from "@dashboard/workspaces/api/helpers";
import { useTheme } from "@mui/material";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

export const SubscriptionAlert = () => {
    const theme = useTheme();
    const isExpired = useCurrentSubscriptionExpired();
    const isExpiringWithinMonth = useSubscriptionExpiringWithinMonth();

    if (isExpired) {
        return (
            <CustomAlert title="Your subscription has expired" severity="error" style={{ marginTop: theme.spacing(3) }}>
                <Trans
                    ns="pages"
                    i18nKey="workspacePage.section.subscriptionAlert.expired"
                    components={{
                        link: <a target="_blank" href="https://emteria.com/p/subscription" rel="noopener noreferrer" />,
                    }}
                />
            </CustomAlert>
        );
    }

    if (isExpiringWithinMonth) {
        return (
            <CustomAlert
                title="Your subscription is nearing expiration"
                severity="warning"
                style={{ marginTop: theme.spacing(3) }}
            >
                <Trans
                    ns="pages"
                    i18nKey="workspacePage.section.subscriptionAlert.expiring"
                    components={{
                        link: <a target="_blank" href="https://emteria.com/p/subscription" rel="noopener noreferrer" />,
                    }}
                />
            </CustomAlert>
        );
    }

    return null;
};
